// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"bc08bfc4","839":"e4809d83"}[chunkId] + ".chunk.js";
};